export const stringArrayToList = (list: string[]): string =>
  list.length === 1
    ? list.toString()
    : [list.slice(0, list.length - 1).join(', '), ...list.slice(-1)].join(' and ');
